import Vue from "vue";
import VueRouter from "vue-router";
import MPC from "../views/MPC";
import Buses from "../views/Buses";
import Bus from "../views/Bus";
import Gens from "../views/Gens";
import Gen from "../views/Gen";
import Branches from "../views/Branches";
import Branch from "../views/Branch";
import DCLines from "../views/DCLines";
import DCLine from "../views/DCLine";
import Options from "../views/Options";
import Import from "../views/Import";
import Export from "../views/Export";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "mpc",
    component: MPC
  },
  {
    path: "/bus",
    name: "buses",
    component: Buses
  },
  {
    path: "/bus/:ord",
    name: "bus",
    component: Bus,
    props: true
  },
  {
    path: "/gen",
    name: "gens",
    component: Gens
  },
  {
    path: "/gen/:ord",
    name: "gen",
    component: Gen,
    props: true
  },
  {
    path: "/gen/:ord/cost",
    name: "genCost",
    component: () => import(/* webpackChunkName: "cost" */ "../views/GenCost"),
    props: true
  },
  {
    path: "/branch",
    name: "branches",
    component: Branches
  },
  {
    path: "/branch/:ord",
    name: "branch",
    component: Branch,
    props: true
  },
  {
    path: "/dcline",
    name: "dclines",
    component: DCLines
  },
  {
    path: "/dcline/:ord",
    name: "dcline",
    component: DCLine,
    props: true
  },
  {
    path: "/import",
    name: "import",
    component: Import
  },
  {
    path: "/export",
    name: "export",
    component: Export
  },
  {
    path: "/options",
    name: "options",
    component: Options
  },
  {
    path: "/about",
    name: "about",
    component: () => import(/* webpackChunkName: "about" */ "../views/About")
  }
];

const router = new VueRouter({
  mode: "history",
  linkExactActiveClass: "active",
  routes
});

export default router;
